import bigcommerceSparkDefaults from '../bigcommerce-spark/config.js';

const baseFitmentFields = window.Convermax.config?.baseFitmentFields || ['Year', 'Make', 'Model'];
const categorySelectionPageUrl = '/categories/';

export default {
  includes: ['bigcommerce-spark'],
  ...bigcommerceSparkDefaults,
  Widgets: [
    ...bigcommerceSparkDefaults.Widgets.filter(
      (w) => !['SearchPage', 'CategoryPage', 'Garage', 'SearchBox', 'FitmentTable'].includes(w.name),
    ),
    {
      name: 'SearchPage',
      location: '#cm_results',
      template: 'SearchPage',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: '#cm_category-page',
      template: 'SearchPage',
      visibleIf: () => window.location.pathname !== categorySelectionPageUrl,
    },
    {
      name: 'HeaderVehicleWidget',
      type: 'VehicleWidget',
      location: '#cm-ymm',
      template: 'fitmentSearch/homeVehicleWidget',
      columnBreakpoint: 650,
      initCollapsed: false,
      fields: !!window.Convermax.config?.extraFieldsAsFilters && baseFitmentFields,
      isVehicleSelectionIsolated: !!window.Convermax.config?.isVehicleSelectionIsolated,
    },
    {
      name: 'Garage',
      location: '#cm-garage',
      template: 'fitmentSearch/garage',
    },
    {
      name: 'SearchBox',
      type: 'SearchBoxDialogButton',
      location: { selector: '#cm-search-box', class: 'cm-search-box' },
      template: 'searchBox/dialogButtonAdaptable',
    },
    {
      name: 'CategoryPageCategoriesCarousel',
      type: 'FacetTiles',
      location: '#cm_category-tile-facet', // or: { insertAfter: '#cm_category-page' }
      template: 'facetTiles/subtitles',
      view: 'carousel', // use 'grid' for a grid instead
      facetField: 'category',
      visibleIf: () => window.location.pathname !== categorySelectionPageUrl,
    },
    {
      name: 'FitmentTable',
      location: '#cm-fitment-table',
      template: 'fitmentSearch/fitmentTable',
    },
  ],
};
